import { Component, Injector, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { accountModuleAnimation } from "@shared/animations/routerTransition";
import { AppComponentBase } from "@shared/app-component-base";
import { AccountServiceProxy, CheckResetCodeExpireDateInput, ForgotPasswordInput} from "@shared/service-proxies/service-proxies";
import { ResetPasswordSmsCodeComponent } from "account/reset-password-sms-code/reset-password-sms-code.component";
import * as moment from "moment";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { interval, Subscription } from "rxjs";
import { finalize } from "rxjs/operators";

@Component({
  templateUrl: "./forgot-password-sms-code-dialog.component.html",
  styleUrls: ['./forgot-password-sms-code-dialog.component.scss'],
  animations: [accountModuleAnimation()],
})
export class ForgotPasswordSmsCodeDialogComponent extends AppComponentBase implements OnInit {
  model = new CheckResetCodeExpireDateInput();
  saving: boolean;

  dataHora:moment.Moment;
  cpf:string;
  tenancyName: string = '';

  naoPodeReenviarToken:boolean = true;
  labelReenviarToken: string;

  private timerToReesendToken:number = 30;

  private subscription: Subscription;
  private forgotPasswordDto = new ForgotPasswordInput();

  constructor(
    injector: Injector,
    private _accountService: AccountServiceProxy,
    public bsModalRef: BsModalRef,
    private _modalService: BsModalService,
  ) {
    super(injector);
  }

  ngOnInit() {
    this.model.cpf = this.cpf;
    this.model.dataHora = this.dataHora;
    this.model.userId = 0;
    this.podeReenviarToken();
  }

  onCodeCompleted($event){
    if($event.length != 6)
      return;
      abp.ui.setBusy();
      this.model.resetCode = $event;
    this._accountService.checkResetCodeExpireDate(this.model).subscribe((retorno) => {
      if(retorno.isExpired)
      {
        abp.ui.clearBusy();
        abp.message.warn('Token inválido! Solicite um novo token', 'Atenção!');
      }
      else {
        abp.ui.clearBusy();
        this.bsModalRef.hide();
          this._modalService.show(ResetPasswordSmsCodeComponent,
            {
              class: 'modal-md',
              initialState: {
                dataHora: this.model.dataHora,
                cpf: this.model.cpf,
                resetCode: this.model.resetCode
              },
            });
      }

    });
  }

  reenviarTokent()
  {
    abp.ui.setBusy();
    this.forgotPasswordDto.cpfCnpj = this.cpf;
    this.forgotPasswordDto.expirationDate = moment();
    this.forgotPasswordDto.tenancyName = this.tenancyName;

    this._accountService
      .forgotPassword(this.forgotPasswordDto)
      .pipe(
        finalize(() => {
          this.saving = false;
          abp.ui.clearBusy();
          this.podeReenviarToken();
        })
      )
      .subscribe((retorno) => {
        if (retorno.success && retorno.isPaciente) {
          abp.message.success(this.l("ReesendTokenMessage"), this.l('Success'));
        }
      });
  }

  podeReenviarToken()
  {
    let timer = this.timerToReesendToken;
    this.naoPodeReenviarToken = true;
    this.labelReenviarToken = `Reenviar Token (${this.timerToReesendToken}s)`;

    this.subscription = interval(1000).subscribe(x => {
      this.labelReenviarToken = `Reenviar Token (${timer}s)`;
      if(timer <= 0)
      {
        this.naoPodeReenviarToken = false;
        this.labelReenviarToken = `Reenviar Token`;
        this.subscription.unsubscribe();
      }
      timer --;
    })
  }

}
